import { EventStatus } from "@/interfaces/entities/event";
import { notificationService } from "@/services/notification.service";
import { testimonialService } from "@/services/testimonial.service";
import { useMutation, useQueryClient } from "@tanstack/react-query";

const useChangeTestimonialStatus = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({
			Id,
			status,
		}: {
			Id: number;
			status: EventStatus;
		}) => await testimonialService.changeStatus(Id, status),
		onSuccess: () => {
			notificationService.success('status changed successfully');
			queryClient.invalidateQueries({ queryKey: ['testimonial'] });
		},
	});
};

export default useChangeTestimonialStatus;